var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',[_vm._v("Comments")]),_c('div',[_c('comments-grid',{attrs:{"show-all-comments":true,"replyToAgentId":_vm.respondToAgentValue,"forwardToClientId":_vm.forwardToClientValue}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }